import { LocalizedText } from '@mews/framework';
import { Stack, StackItem, Typography } from '@optimus-web/core';
import { AssistantSearchType } from '../../assistantSearchTypes';
import { EntityKeys } from '../../entityKeys';
import { ThinDivider } from '../styles';

interface ListTitleProps {
    searchType: AssistantSearchType;
    hideDivider?: boolean;
}

export interface ResultListProps {
    searchTerm: string;
}

export const ListTitle = ({ searchType, hideDivider = false }: ListTitleProps) => (
    <Stack vertical spacing="50">
        <StackItem>
            <Typography textStyle="bodySmall" variant="tertiary" as="div">
                <LocalizedText textKey={EntityKeys[searchType]} />
            </Typography>
        </StackItem>
        {!hideDivider && (
            <StackItem>
                <ThinDivider />
            </StackItem>
        )}
    </Stack>
);
